import { render } from "./ChatViewer.vue?vue&type=template&id=8d1d0ba2"
import script from "./ChatViewer.vue?vue&type=script&lang=js"
export * from "./ChatViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__